<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Справочник суммы по филиалам зарубежных вузов</h3>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="search" class="form-label col-md-2"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по коду и наименованию"
                       id="search"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="filterYear" class="form-label col-md-2">
              Год
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.year" id="filterYear"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="university" class="form-label col-md-2">
              ВУЗ
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.universityId" id="university"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="university in universities" :key="university.universityId"
                        :value="university.universityId">
                  {{ university.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(year)="data">
        <div class="sortable-container none"
             @click="onSortChanged('year')"
             :class="{'ascending': page.sort.year === 'ASC', 'descending': page.sort.year === 'DESC'}">
          Год
        </div>
      </template>
      <template #head(code)="data">
        <div class="sortable-container none"
             @click="onSortChanged('code')"
             :class="{'ascending': page.sort.code === 'ASC', 'descending': page.sort.code === 'DESC'}">
          Код специальности
        </div>
      </template>
      <template #head(nameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('nameRu')"
             :class="{'ascending': page.sort.nameRu === 'ASC', 'descending': page.sort.nameRu === 'DESC'}">
          Наименование специальности
        </div>
      </template>
      <template #head(sum)="data">
        <div class="sortable-container none"
             @click="onSortChanged('sum')"
             :class="{'ascending': page.sort.sum === 'ASC', 'descending': page.sort.sum === 'DESC'}">
          Сумма 1 месяца
        </div>
      </template>
      <template #head(actions)="data"  v-if="isAdmin()">
      </template>


      <template #cell(year)="data">
        {{ data.item.year }}
      </template>
      <template #cell(code)="data">
        {{ data.item.profession.code }}
      </template>
      <template #cell(nameRu)="data">
        <a :href="`/professions-foreign-amounts/${data.item.uuid}`">
          {{ data.item.profession.nameRu }}
        </a>
      </template>
      <template #cell(sum)="data">
        {{ data.item.sum }}
      </template>
      <template #cell(actions)="data"  v-if="isAdmin()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    v-if="false"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import professionForeignAmountsService from "@/services/professionForeignAmountsService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      page: {
        filter: {
          search: null,
          year: new Date().getFullYear(),
          universityId: null
        },
        sort: {
          universityId: null,
          bin: null,
          year: null,
          code: null,
          nameRu: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'year', label: 'Год', sortable: true},
        {key: 'code', label: 'Код специальности', sortable: true},
        {key: 'nameRu', label: 'Наименование специальности', sortable: true},
        {key: 'sum', label: 'Сумма 1 месяца', sortable: true},
        {key: 'actions', label: '', sortable: false}
      ],
      universities: [],
      items: [],
      years: Array.from({length: 11}, (v, i) => 2019 + i),
      year: new Date().getFullYear()
    };
  },
  methods: {
    async reloadList() {
      this.isLoading = true;
      const response = await professionForeignAmountsService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await professionForeignAmountsService.deleteByUuid(item.uuid);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    isAdmin() {
      return delegationService.isAdmin();
    }
  },
  mounted() {
    this.initUniversities();
    this.reloadList();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../../assets/asc.svg") !important;
}

.descending {
  background-image: url("../../assets/desc.svg") !important;
}

.none {
  background-image: url("../../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
